import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Autoplay, FreeMode } from 'swiper/modules';
import {MIN_DESKTOP, MIN_TABLET} from "../constants";

export default () => ({
    step: 3,
    moveSlides() {
        this.$refs.slider.scrollLeft += this.step;
        if (this.$refs.slider.scrollLeft >= this.$refs.slider.scrollWidth / 2) {
            this.$refs.slider.scrollLeft = 0;
        }
        requestAnimationFrame(this.moveSlides.bind(this));
    },
    init() {
        let slides = Array.from(this.$refs.slider.children);
        slides.forEach(slide => {
            let clone = slide.cloneNode(true);
            this.$refs.slider.appendChild(clone);
        });
        this.moveSlides();
    }
});